export const HOME_SECTIONS = ["#about", "#how-it-works", "#products"]

export const QUICKSHIP_GTAG = "GTM-WNX95F6H"
